// Layer 3: the one pluralizing formatter for small counted nouns on the glass.

/** `11 steps` / `1 step` / `0 steps` — regular nouns only. */
export function pluralCount(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
